var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{class:[_vm.$style.heading, _vm.$sizeStyle[_vm.sizeClass]]},[(_vm.iconClass)?_c('i',{class:[_vm.iconClass, _vm.$style.icon]}):_vm._e(),_vm._v(_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }